/*
 * @Author: 谢树和 shuhe.xie@southgis.com
 * @Date: 2022-10-12 09:47:22
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @LastEditTime: 2022-11-03 15:34:27
 * @FilePath: \standard-v5\src\utils\api\opinionPublish.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Http from '@/utils/httpRequest'
const axios = new Http()

export default {
  // 意向发布查询-获取列表
  queryIntention: data => {
    return axios.post('/onlineServiceProject/dchy/public/queryIntention', data)
  },
  // 意向发布查询详情
  getIntention: data => {
    return axios.get('/onlineServiceProject/dchy/public/getIntention', data)
  },
  // 获取意向发布配置
  getIntentionConfig: data => {
    return axios.get('/onlineServiceProject/public/getIntentionConfig', data)
  },
  // 获取历史项目
  getHistoryProject: data => {
    return axios.post('/onlineServiceProject/dchy/public/getHistoryProject', data)
  },
  // 获取委托事项
  getItemWithNote: data => {
    return axios.get('/onlineServiceProject/public/getItemWithNote', data)
  },
  // 查看已选择的测绘机构
  getSelectChdw: data => {
    return axios.post('/onlineServiceProject/public/getSelectChdw', data)
  },
  // 提交意向发布
  submitIntention: data => {
    return axios.post('/onlineServiceProject/public/submitIntention', data)
  },
  // 终止意向发布
  cancelIntention: data => {
    return axios.post('/onlineServiceProject/dchy/public/cancelIntention', data)
  },
  // 继续发布意向
  continueIntention: data => {
    return axios.post('/onlineServiceProject/dchy/public/continueIntention', data)
  },
  // 删除意向
  deleteIntention: data => {
    return axios.post('/onlineServiceProject/dchy/public/deleteIntention', data)
  },
  // 根据测量事项key获取value
  getClsxValue: data => {
    return axios.post('/applet/public/getClsxValue', data)
  },
}